import PropTypes from 'prop-types';
import React from 'react';

import { CheckboxStyled } from './TrlCheckButton.styles';

export const TrlCheckButton = (props) => {
  const { value, relatedField, handleChange, disabled, size } = props;

  return (
    <CheckboxStyled
      checked={value === 'Y'}
      onChange={handleChange}
      value={value}
      id={relatedField}
      disabled={disabled}
      size={size}
    />
  );
};

TrlCheckButton.propTypes = {
  relatedField: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
};
